import React, { createContext, useEffect, useState, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getStatus, signIn } from '../api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const storedAuth = window.localStorage.getItem('guest');
  const [guestId, setGuestId] = useState(storedAuth);
  const [status, setStatus] = useState();

  useEffect(() => {
    if (guestId)
      getStatus(
        guestId,
        (status) => {
          setStatus(status);
        },
        (error) => {
          console.error(error);
        }
      );
  }, [guestId, setStatus]);

  const handleSignIn = (name, callback, error) => {
    signIn(
      name,
      (guest) => {
        if (guest && guest.length) {
          setGuestId(guest[0].id);
          window.localStorage.setItem('guest', guest[0].id);
          if (callback) callback(guest[0]);
        } else if (error) {
          error('user not found');
        }
      },
      (err) => {
        console.error('Login failed: ', JSON.stringify(err));
        setGuestId(undefined);
        window.localStorage.removeItem('guest');
        if (error) error(err);
      }
    );
  };

  return (
    <AuthContext.Provider value={{ guestId, status, handleSignIn }}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useAuth = () => useContext(AuthContext);

export const withAuth = (WrappedComponent) => {
  const ProtectedComponent = (props) => {
    const { guestId } = useAuth();

    if (!guestId) {
      return <Navigate to="/login" replace />;
    }

    return <WrappedComponent {...props} />;
  };

  ProtectedComponent.displayName = `withAuth(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return ProtectedComponent;
};
